import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import LoadingButton from '../LoadingButton.jsx';


const NavBar = styled.div`
  margin-top:25px;
`;

const SkipButtonStyled = styled.button`
  display: block;
  margin-top: 15px;
  width: 100%;
  margin-bottom: 5px;
  border: none;
  font-size: 18px;
  padding: 0.75rem;
  font-weight: 300;
  background: none;
`;

function NextButton({
  isLoading, onClick, disabled, label,
}) {
  const { t } = useTranslation('activation_wizard');

  return (
    <LoadingButton
      className="nextButton"
      isLoading={isLoading}
      onClick={(onClick) ? () => onClick() : undefined}
      disabled={disabled}>
    {label || t('next_button_label')}
    </LoadingButton>
  );
}

function BackButton({ onClick }) {
  const { t } = useTranslation('activation_wizard');

  return (
    <button
      type="button"
      className="backButton"
      onClick={() => onClick()}>
      &lt; {t('back_button_label')}
    </button>
  );
}

function SkipButton({ onClick }) {
  const { t } = useTranslation('activation_wizard');

  return (
    <SkipButtonStyled onClick={onClick}>{t('skip_button_label')}</SkipButtonStyled>
  );
}

export default NavBar;
export { NextButton, SkipButton, BackButton };
